import styled from 'styled-components'
import { sizes } from '../../util'

export const Wrapper = styled.div`
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '100rem')};
  /* margin: ${({ width }) => (width === 'full' ? '0 auto' : '1rem')}; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: ${({ bg }) => bg || 'transparent'};
  @media (min-width: ${sizes.medium}) {
    padding: ${({ width }) => (width === 'full' ? '0' : '0 4rem')};
  }
`

export const Backg = styled.div`
  background: ${({ theme }) => theme.colorAlt};
  min-height: 100vh;
`

export const Box = styled.div`
  width: 100%;
  background: white;
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '44rem')};
  color: ${({ theme }) => theme.colorText};
  align-self: ${({ align }) => align};
  ${({ shadow }) => shadow && 'box-shadow: 0 0 1.5rem rgba(0,0,0,0.15);'}
`

export const Text = styled.p`
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '1.5rem')};
  line-height: 1.3;
  padding: ${({ size }) => (size === 'big' ? '2rem 4rem' : '2rem 4rem 4rem')};
  ${({ align }) => align && `text-align: ${align}`}
  bold {
    font-weight: 600;
  }
  @media (max-width: ${sizes.medium}) {
    font-size: ${({ size }) => (size === 'big' ? '1.75rem' : '1.25rem')};
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem' : '2rem 2rem 2rem')};
  }
  @media (max-width: ${sizes.small}) {
    font-size: ${({ size }) => (size === 'big' ? '1.5rem' : '1rem')};
  }
`

export const Tag = styled.p`
  font-size: 4rem;
  line-height: 1.1;
  padding: 3rem 4rem 0;
  font-weight: 300;
  @media (max-width: ${sizes.medium}) {
    font-size: 3.5rem;
    padding: 3rem 2rem 0;
  }
  @media (max-width: ${sizes.small}) {
    font-size: 2.5rem;
  }
`

export const Top = styled.div`
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '0.75rem')};
  font-weight: ${({ size }) => (size === 'big' ? 400 : 600)};
  text-transform: ${({ size }) => (size === 'big' ? 'none' : 'uppercase')};
  letter-spacing: 0.03em;
  line-height: 1.3;
  padding: ${({ size }) => (size === 'big' ? '2rem 4rem 1rem' : '1rem 4rem')};
  border-bottom: 1px solid;
  @media (max-width: ${sizes.medium}) {
    font-size: ${({ size }) => (size === 'big' ? '2rem' : '0.75rem')};
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem 1rem' : '1rem 2rem')};
  }
`

export const LogoWrapper = styled.div`
  position: fixed;
  z-index: 1;
  will-change: transform;
  left: 0;
  right: 0;
  margin: 0 2rem;
  ${({ pgPos, pgSize }) => pgPos === 'left' && pgSize === 'half' && 'right: 50%'}
  ${({ pgPos, pgSize }) => pgPos === 'right' && pgSize === 'half' && 'left: 50%'}
  ${({ pos }) => (pos === 'top' ? 'top: 2rem' : 'bottom: 2rem')};
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent};
  @media (max-width: ${sizes.medium}) {
    ${({ pgPos, pgSize }) => pgPos === 'left' && pgSize === 'half' && 'right: 0'}
    ${({ pgPos, pgSize }) => pgPos === 'right' && pgSize === 'half' && 'left: 0'}
  }
  @media (max-width: ${sizes.small}) {
    margin: 0 1rem;
    ${({ pos }) => (pos === 'top' ? 'top: 1rem' : 'bottom: 1rem')};
  }
`

export const Galleries = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  div {
    position: relative;
    padding: 2rem;
    border-bottom: 1px solid;
    &:nth-child(odd) {
      border-right: 1px solid;
    }
    &:hover {
      p {
        opacity: 1;
      }
      svg {
        opacity: 0.2;
      }
    }
  }
  p {
    font-size: 2.75rem;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
    opacity: 0;
  }
  svg {
    width: 100%;
    height: 100%;
    fill: ${({ theme }) => theme.color};
  }
`

export const ShapeContainer = styled.div`
  position: fixed;
  will-change: transform;
  top: 50%;
  left: ${({ size, pos }) =>
    (size === 'half' && pos === 'left' ? '25%' : size === 'half' && pos === 'right' ? '75%' : '50%')};
  transform-origin: center, center;
  transform: ${({ flipX, flipY, rotate }) =>
    `translate(-50%, -50%)
      rotate(${rotate}deg)
      ${flipY ? 'scaleY(-1)' : 'scaleY(1)'}
      ${flipX ? 'scaleX(-1)' : 'scaleX(1)'}
    `};
  width: ${({ size }) => (size === 'half' ? '50vw' : '100vw')};
  height: 100vh;
  ${({ rotate, size }) =>
    (rotate === 90 || rotate === 270
      ? size === 'half'
        ? 'width: 100vh; height: 50vw'
        : 'width: 100vh; height: 100vw'
      : null)}
  svg {
    width: 100%;
    height: 100%;
    fill: ${({ theme }) => theme.color};
  }

  @media (max-width: ${sizes.medium}) {
    width: ${({ size }) => (size === 'half' ? '100vw' : '100vw')};
    left: ${({ size, pos }) =>
    (size === 'half' && pos === 'left'
      ? '50%'
      : size === 'half' && pos === 'right'
        ? '50%'
        : '50%')};
  }
`
